<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">
        Lequel des réactifs suivants est le plus approprié pour réduire une imine en composé amine?
      </p>

      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mb-0 pl-6">
        <v-radio
          v-for="option in options"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default {
  name: 'chemUott1721B_Task29',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
      options: [
        {
          text: '$\\ce{NaCNBH3}$ puisqu’il est non-réactif en milieu acide',
          value: 'sodiumNonreactive',
        },
        {
          text: '$\\ce{LiAlH4}$ puisqu’il contient l’hydrure le plus nucléophile',
          value: 'lithium',
        },
        {
          text: '$\\ce{NaBH4}$ puisqu’il contient l’hydrure le plus nucléophile',
          value: 'borohydride',
        },
        {
          text: '$\\ce{NaCNBH3}$ puisqu’il contient l’hydrure le plus nucléophile',
          value: 'sodiumNucleophilic',
        },
      ],
    };
  },
};
</script>
